<template>
	<div class="pronto-container startup">
		<CloudLoader animate v-if="showLoadingScreen" />
		<App v-if="!showLoadingScreen" />
	</div>
</template>
<script setup>
import { onMounted, nextTick, ref } from 'vue'
import App from './App.vue'
import { CloudLoader } from '@/components/common'
import { checkForLoginToken } from '@/helpers/auth'
import { prepareAppConfig } from '@/helpers/startup'

const showLoadingScreen = ref(true)

onMounted(async () => {
	await checkForLoginToken()
	await prepareAppConfig()
	await nextTick()
	showLoadingScreen.value = false
})
</script>
